import styled, { css } from 'styled-components'

import ArrowBlueIco from '../../../assets/arrow.svg'
import ArrowWhiteIco from '../../../assets/arrow_white.svg'

export const OpenCloseCaret = styled('span').withConfig({
  shouldForwardProp: (prop) => !['state', 'colorTheme'].includes(prop)
})<{ state: 'open' | 'close'; colorTheme: 'light' | 'dark' }>`
  display: inline-block;
  -webkit-transition: 0.25s;
  transition: 0.25s;
  bottom: 0;
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  cursor: pointer;
  justify-self: flex-end;
  background: url(${(props) => (props.colorTheme === 'light' ? ArrowWhiteIco : ArrowBlueIco)}) no-repeat center center;
  ${({ state }) =>
    state === 'open' &&
    css`
      transform: rotate(180deg);
    `}
`
